export const statuses: TableModule = {
    name: "statuses",
    route: "spa.basedata.statuses",
    defaultOrder: {
        column: "sort",
        direction: "asc"
    },
    columns: [
        {
            name: "name_management_area",
            sortable: true,
            pageLink: true,
            mobile: true
        }, {
            name: "name_application_area",
            sortable: true,
            breakpoint: "lg",
        }, {
            name: "model_class",
            sortable: true,
            breakpoint: "md"
        }, {
            name: "statusNotifications",
        }, {
            name: "sort",
            sortable: true,
            width: "w-1/6 md:w-1/12"
        }
    ],
    filters: [
        {
            name: "name_management_area",
            column: "name_management_area",
            type: "string"
        }, {
            name: "name_application_area",
            column: "name_application_area",
            type: "string"
        }
    ],
    quickFilters: [
        {
            name: "qf_modelClassProcessOnly",
            column: "model_class",
            value: "App\\Models\\Processes\\Process",
            operator: "="
        }, {
            name: "qf_modelClassFormProcessOnly",
            column: "model_class",
            value: "App\\Models\\Processes\\FormProcess",
            operator: "="
        }
    ],
    tools: [
        {
            name: "statuses.create",
            isCreateAction: true,
            ability: [
                "create",
                "statuses"
            ]
        }
    ]
}